export default __webpack_public_path__ + "static/media/charge_pump_positive_2_diodes.f81ba048.svg";